module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/december-c87d048a31bedf85cb9e7f69b7ab10f6.png";